import type { Guide } from '../types';

/**
 * S-22.10-01 — centrum ról i uprawnień (decyzja użytkownika 22.10.2026; scenariusz e2e 23). Tylko
 * administrator — nagrywarka przechodzi kroki kontem administratora pokazowego. Czynności tylko otwierają
 * karty i zakładki, niczego nie zapisują (zapis z powodem opisuje tekst kroku).
 */
export const guide: Guide = {
  flagKey: 'roleCenter',
  title: 'Centrum ról i uprawnień',
  whatItDoes:
    'W sekcji „Administracja” nowa pozycja „Centrum ról i uprawnień”, dostępna wyłącznie dla administratora. Role są kartami z ikoną, opisem, liczbą kont i uprawnień. Na karcie roli: „Uprawnienia” — pogrupowane przełączniki z opisem, co każde pozwala robić; „Co widzi” — pozycje menu, ekrany, sekcje kart i kafelki pulpitu z przełącznikami widoczności; „Użytkownicy” i „Historia”. Element, do którego rola nie ma uprawnienia, jest wyszarzony z wyjaśnieniem — ukrycie niczego nie odbiera, o dostępie rozstrzyga serwer. Każda zmiana zapisuje się oknem z listą „było → jest” i obowiązkowym powodem. Do tego macierze rola × uprawnienie i rola × widoczność, „Zobacz jako” (menu i sekcje oczami wybranej roli) i własne role, które można nadać kontom. Administrator ma zawsze wszystko — tego nie da się zmienić. Dane startowe to dokładnie dzisiejsze uprawnienia.',
  audience: ['administrator'],
  presentationItems: ['S-22.10-01'],
  steps: [
    {
      route: '/role-center',
      target: 'role-list',
      title: 'Lista ról',
      description:
        'Każda rola to karta: ikona, nazwa, opis, liczba kont i uprawnień. Rola systemowa ma znacznik, administrator — kłódkę „stała”. „Dodaj rolę” zakłada rolę własną, także na wzór istniejącej.',
      action: 'Otwórz „Centrum ról i uprawnień” w menu (grupa „Administracja”).',
      recorder: { account: 'admin' },
    },
    {
      route: '/role-center',
      target: 'role-permissions',
      title: 'Uprawnienia roli z opisami',
      description:
        'Na karcie roli uprawnienia są pogrupowane: Planowanie FTL, Trade, Przyjęcie zleceń, Administracja, Ogólne. Przy każdym ikona, nazwa i opis, co pozwala robić. Zmiana przełącznika czeka na zapis; „Zapisz zmiany” otwiera okno z listą „było → jest” i polem powodu.',
      action: 'Kliknij kartę roli, np. „Planista FTL (opiekun pojazdów)”.',
      recorder: { account: 'admin', actions: [{ kind: 'click', target: 'role-card-PLANNER_FTL' }] },
    },
    {
      route: '/role-center',
      target: 'role-visibility',
      title: 'Co widzi rola',
      description:
        'Pozycje menu, ekrany, sekcje kart (np. „Rekomendowane pojazdy”, „Przewoźnicy z historią”, „Zapis do VIA”) i kafelki pulpitu — każdy z opisem i przełącznikiem widoczności. Element, do którego rola nie ma uprawnienia, jest wyszarzony z wyjaśnieniem.',
      action: 'Na karcie roli przejdź na zakładkę „Co widzi”.',
      recorder: {
        account: 'admin',
        actions: [
          { kind: 'click', target: 'role-card-TRADER' },
          { kind: 'click', target: 'role-tab-visibility' },
        ],
      },
    },
    {
      route: '/role-center',
      target: 'role-matrix-permissions',
      title: 'Macierz rola × uprawnienie',
      description:
        'Podgląd całości: wszystkie role w kolumnach, uprawnienia w wierszach, filtr grup. Kłódka oznacza to, czego nie zmienia się w centrum. Kliknięcie nazwy roli otwiera jej kartę.',
      action: 'Wybierz zakładkę „Macierz uprawnień”.',
      recorder: { account: 'admin', actions: [{ kind: 'clickText', text: 'Macierz uprawnień' }] },
    },
    {
      route: '/role-center',
      target: 'role-see-as',
      title: 'Zobacz jako',
      description:
        'Menu i sekcje oczami wybranej roli — z ustawień centrum, bez przelogowania. Pod menu lista sekcji, ekranów i kafelków, które rola widzi, i tych, których nie widzi.',
      action: 'Wybierz zakładkę „Zobacz jako” i rolę z listy.',
      recorder: { account: 'admin', actions: [{ kind: 'clickText', text: 'Zobacz jako' }] },
    },
  ],
};
